var map = {
	"./appuntamento-dark.svg": 1296,
	"./appuntamento.svg": 1297,
	"./attivita-dark.svg": 1298,
	"./attivita-veloci-dark.svg": 1299,
	"./attivita-veloci.svg": 1300,
	"./attivita.svg": 1301,
	"./azioni-dark.svg": 1302,
	"./azioni.svg": 1303,
	"./calendario-dark.svg": 1304,
	"./calendario.svg": 1305,
	"./catalogo-dark.svg": 1306,
	"./catalogo.svg": 1307,
	"./categorie-dark.svg": 1308,
	"./categorie.svg": 1309,
	"./contabilita-dark.svg": 1310,
	"./contabilita.svg": 1311,
	"./dashboard-dark.svg": 1312,
	"./dashboard.svg": 1313,
	"./doc-contabili-dark.svg": 1314,
	"./doc-contabili.svg": 1315,
	"./fatturazione-elettronica-dark.svg": 1316,
	"./fatturazione-elettronica.svg": 1317,
	"./generale-dark.svg": 1318,
	"./generale.svg": 1319,
	"./impostazioni-dark.svg": 1320,
	"./impostazioni.svg": 1321,
	"./incassi-dark.svg": 1322,
	"./incassi.svg": 1323,
	"./listini-dark.svg": 1324,
	"./listini.svg": 1325,
	"./logistica-dark.svg": 1326,
	"./logistica.svg": 1327,
	"./lotti-seriali-dark.svg": 1328,
	"./lotti-seriali.svg": 1329,
	"./magazzini-dark.svg": 1330,
	"./magazzini.svg": 1331,
	"./movimenti-dark.svg": 1332,
	"./movimenti.svg": 1333,
	"./organizzazione-dark.svg": 1334,
	"./organizzazione.svg": 1335,
	"./personalizza-dark.svg": 1336,
	"./personalizza.svg": 1337,
	"./prima-nota-dark.svg": 1338,
	"./prima-nota.svg": 1339,
	"./prodotti-dark.svg": 1340,
	"./prodotti.svg": 1341,
	"./punti-vendita-dark.svg": 1342,
	"./punti-vendita.svg": 1343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1073;